import { FormControl } from '@angular/forms';

export function numberValidator(control: FormControl): { [key: string]: any } {
  const emailRegexp = /^\d+$/i;
  if (control.value && !emailRegexp.test(control.value)) {
    return { invalidNumber: true };
  }
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/shared/validators/numberValidator.ts